import { trackEvent } from 'analytics/trackFunctions'
import RoundedIcon from 'components/RoundedIcon'
import TextButton from 'components/textButton'
import { ExternalLink } from 'assets/icons'
import { CardDiscountBg } from './CardDiscount'
import PaymentMethodsIcons from './PaymentMethodsIcons'

interface DiscountInfoProps {
  description: string
  duration: string
  category: string
  discount: string
  bgImage: string
  emoji: string
  frequency: string
  limit?: string | null
  paymentMethodDescription: string
  paymentMethods: {
    wayni: string
    mastercard: string
    gpay: string
  }
  termsUrl: string
}

const DiscountInfo = ({
  description,
  duration,
  bgImage,
  emoji,
  category,
  discount,
  frequency,
  limit = null,
  termsUrl,
  paymentMethodDescription,
  paymentMethods
}: DiscountInfoProps) => (
  <div>
    <CardDiscountBg isDetail frequency={frequency} bgImage={bgImage} />
    <div>
      <div className='flex items-center gap-2 my-4'>
        <RoundedIcon
          className='!w-12 !h-12'
          icon={<img className='w-8' src={emoji} alt='' />}
        />
        <div>
          <p className='font-bold text-gray-900 text-2xs'>{category}</p>
          <p className='text-base font-bold leading-5 text-black'>{discount}</p>
          <div className='flex gap-1 items-center'>
            <p className='font-bold text-gray-900 text-2xs'>
              {paymentMethodDescription}
            </p>
            <PaymentMethodsIcons isDetail paymentMethods={paymentMethods} />
          </div>
        </div>
      </div>
      <div className='text-black text-xs space-y-4 leading-5'>
        <p>{description}</p>
        <p>
          <span className='font-bold'>Validez: </span>
          {duration}
        </p>
        {limit ? (
          <p>
            <span className='font-bold'>Tope de reintegro: </span>
            {limit}
          </p>
        ) : null}
        <div className='flex justify-center items-center align-center gap-1'>
          <TextButton
            handleFunction={() => {
              trackEvent({
                eventName: `bille_detalle_descuento_boton_tyc`
              })
              window.open(termsUrl, '_blank')
            }}
          >
            Ver términos y condiciones <ExternalLink className='ml-1' />
          </TextButton>
        </div>
      </div>
    </div>
  </div>
)

export default DiscountInfo
